import { Card, CardContent, CardHeader } from "@mui/material";
import { ComponentProps } from "@arelia-types/widget";
import { useMyContentSongs } from "../my-content.api";
import MyContentSongsPresenter from './MyContentSongsPresenter';
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";

export default function MyContentSongsContainer({ config }: ComponentProps) {
  const { data, isLoading } = useMyContentSongs();

  return (
    <Card sx = {{minHeight: "250px"}}>
      <CardHeader title={config.name} />
      <SpinnerWrapper loading={isLoading}>
        <CardContent>
          <MyContentSongsPresenter data={data} />
        </CardContent>
      </SpinnerWrapper>
    </Card>
  );
}
